import * as React from 'react'
import { UploadFile } from 'antd/lib/upload/interface'
import styled from 'styled-components'
import Upload from 'web-makeup/dist/Upload'

const StyledUpload = styled(Upload as any)`
  display: block;
`

export interface LogoUploadProps {
  onStart?(file: UploadFile): void
  onSuccess?(file: UploadFile): void
  onError?(error: Error): void
}

const LogoUpload: React.FC<LogoUploadProps> = ({ onSuccess }) => {
  const [loading, setLoading] = React.useState(false)

  const cloudinaryAction = window.env && window.env.CLOUDINARY_UPLOAD_URL
  const uploadPreset = window.env && window.env.CLOUDINARY_UPLOAD_PRESET

  const beforeUpload = file => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      alert('You can only upload JPG/PNG file!')
    }
    const isLt2M = file.size / 1024 / 1024 < 15
    if (!isLt2M) {
      alert('Image must smaller than 15MB!')
    }
    return isJpgOrPng && isLt2M
  }

  const handleChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(true)
    }
  }

  return (
    <StyledUpload
      listType="picture"
      action={cloudinaryAction}
      name="avatar"
      showUploadList={false}
      data={file => ({ file, upload_preset: uploadPreset })}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      onSuccess={e => {
        onSuccess && onSuccess(e)
        setLoading(false)
      }}
    >
      {loading ? <a>Loading....</a> : <a>Upload logo</a>}
    </StyledUpload>
  )
}

export default LogoUpload



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/LogoUpload/LogoUpload.tsx